import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';

import './App.css';
import { AppRouter } from './router';
import { SnackbarProvider } from 'notistack';
import { apolloClient } from './api/apolloClient';

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <SnackbarProvider maxSnack={6}>
          <AppRouter />
        </SnackbarProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
